export default "__VITE_ASSET__8384770c__"